import { render, staticRenderFns } from "./EditFailedDdPaymentCharge.vue?vue&type=template&id=52d762bb&"
import script from "./EditFailedDdPaymentCharge.vue?vue&type=script&lang=js&"
export * from "./EditFailedDdPaymentCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditFailedDdPaymentCharge.vue"
export default component.exports